import { render, staticRenderFns } from "./TheRegularAdvisor.vue?vue&type=template&id=989cfc48&scoped=true&"
import script from "./TheRegularAdvisor.vue?vue&type=script&lang=js&"
export * from "./TheRegularAdvisor.vue?vue&type=script&lang=js&"
import style0 from "./TheRegularAdvisor.vue?vue&type=style&index=0&id=989cfc48&lang=less&scoped=true&"
import style1 from "./TheRegularAdvisor.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989cfc48",
  null
  
)

export default component.exports